import { Routes } from '@angular/router';

export const celebrationRoutes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/celebrations',
    pathMatch: 'full',
  },
  {
    path: 'celebration/:id',
    loadComponent: () =>
      import('#pages/celebration-answer/celebration-answer.page').then(
        (m) => m.CelebrationAnswerPage
      ),
  },
  {
    path: 'celebration',
    loadComponent: () =>
      import('#pages/celebration-answer/celebration-answer.page').then(
        (m) => m.CelebrationAnswerPage
      ),
  },
];
